import { useEffect, useState } from "react";

import { StaticApi } from "../api";
import { PageHeader } from "../components/PageHeader";

import "../assets/scss/pages/_static.scss";
import Config from "../Config";

export const Static = ({ id, initialPage = null }) => {
	const [staticInfo, setStaticInfo] = useState(initialPage || {});

	useEffect(() => {
		if (initialPage?.content_id === id) return;
		StaticApi.getInfo(id).then(({ page }) => {
			setStaticInfo(page);
		});
	}, [id, initialPage?.content_id]);

	return (
		staticInfo &&
		staticInfo.title && (
			<>
				<title>{Config.title(staticInfo.title)}</title>
				<div className={`static ${staticInfo.title.replaceAll(" ", "-").toLowerCase()}`}>
					<PageHeader title={staticInfo.title} />

					<div
						className="container page-content"
						dangerouslySetInnerHTML={{ __html: staticInfo.content }}
					></div>
				</div>
			</>
		)
	);
};
